import { Link } from "react-router-dom";
import { Phone, Mail, Globe } from "lucide-react";
import { CONTACT, SPORTS } from "@/data/site";

export const Footer = () => {
  return (
    <footer className="bg-[#0B3B38] text-teal-50">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-2">
          <div className="inline-flex items-center rounded-2xl bg-white px-4 py-3 shadow-lg">
            <img src="/playlab-logo.png" alt="SplayLab" className="h-16 w-auto" />
          </div>
          <p className="mt-4 max-w-xs text-sm text-teal-100/75">
            Custom-tailored, science-backed movement programs for early learning
            up to Year 2 — WWCC verified, fully insured, zero lock-in.
          </p>
        </div>

        <div>
          <h4 className="font-head text-sm font-extrabold uppercase tracking-wider text-teal-200/70">
            Get in touch
          </h4>
          <a href={CONTACT.phoneHref} data-testid="footer-phone" className="mt-3 flex items-center gap-2 text-base font-extrabold text-white hover:text-[#FACC15]">
            <Phone className="h-4 w-4" /> {CONTACT.phone}
          </a>
          <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="mt-2 flex items-center gap-2 text-sm text-teal-100/85 hover:text-[#FACC15]">
            <Mail className="h-4 w-4" /> {CONTACT.email}
          </a>
          <a href={CONTACT.websiteHref} target="_blank" rel="noopener noreferrer" data-testid="footer-website" className="mt-2 flex items-center gap-2 text-sm text-teal-100/85 hover:text-[#FACC15]">
            <Globe className="h-4 w-4" /> {CONTACT.website}
          </a>
        </div>

        <div>
          <h4 className="font-head text-sm font-extrabold uppercase tracking-wider text-teal-200/70">
            Programs
          </h4>
          <ul className="mt-3 space-y-2">
            {SPORTS.map((s) => (
              <li key={s.slug}>
                <Link to={`/sports/${s.slug}`} className="text-sm text-teal-100/85 hover:text-[#FACC15]">
                  {s.name}
                </Link>
              </li>
            ))}
            <li><Link to="/science" className="text-sm text-teal-100/85 hover:text-[#FACC15]">The Movement Science</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-teal-900/60 py-5 text-center text-xs text-teal-100/50">
        © {new Date().getFullYear()} SplayLab. Zero lock-in — nothing is confirmed until we accept your request.
      </div>
    </footer>
  );
};
